export const dataCandidateData = {
  type: 'object',
  required: ['Firstname', 'Lastname', 'DOB'],
  properties: {
    Firstname: {
      type: 'string',
      minLength: 1,
    },
    Middlename: {
      type: ['null', 'string'],
    },
    Lastname: {
      type: 'string',
      minLength: 1,
    },
    RefNumber: {
      type: ['null', 'string'],
    },
    DOB: {
      type: 'object',
      required: ['DD', 'MM', 'YYYY'],
      properties: {
        DD: {
          type: 'string',
          minLength: 1,
        },
        MM: {
          type: 'string',
          minLength: 1,
        },
        YYYY: {
          type: 'string',
          minLength: 1,
        },
      },
    },
  },
};
